// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"8b5655a3","202":"b1533976"}[chunkId] + ".chunk.css";
};